<!-- CalendlyModal.vue -->
<template>
    <div class="calendly-modal">
        <el-dialog
            v-model="visible"
            :title="$trans('profile_dossier.make_appointment')"
            width="1100px"
            @opened="loadCalendly"
            @closed="clearCalendly"
        >
            <div
                id="calendly-embed"
                style="min-width: 320px; height: 700px; position: relative"
            >
            </div>
            <template #footer>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "CalendlyModal",
    props: {
        calendlyUrl: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            visible: this.modelValue,
        };
    },
    watch: {
        modelValue(val) {
            this.visible = val;
        },
        visible(val) {
            this.$emit("update:modelValue", val);
        },
    },
    methods: {
        loadCalendly() {
            const embed = document.getElementById("calendly-embed");
            if (!embed) return;
            this.$functions.showLoader();

            const waitForCalendly = setInterval(() => {
                if (
                    window.Calendly &&
                    typeof Calendly.initInlineWidget === "function"
                ) {
                    Calendly.initInlineWidget({
                        url: this.calendlyUrl,
                        parentElement: embed,
                        prefill: {},
                        utm: {},
                    });

                    const waitForIframe = setInterval(() => {
                        if (embed.querySelector("iframe")) {
                            clearInterval(waitForIframe);
                            setTimeout(() => {
                                const loader =
                                    this.$functions.hideLoader();
                            }, 1000);
                        }
                    }, 500);

                    clearInterval(waitForCalendly);
                }
            }, 500);
        },
        clearCalendly() {
            const embed = document.getElementById("calendly-embed");
            if (embed) embed.innerHTML = "";
        },
    },
    mounted() {
        if (
            !document.querySelector(
                'script[src="https://assets.calendly.com/assets/external/widget.js"]'
            )
        ) {
            const script = document.createElement("script");
            script.src =
                "https://assets.calendly.com/assets/external/widget.js";
            script.async = true;
            document.head.appendChild(script);
        }
    },
};
</script>

<style scoped>
.calendly-modal :deep(.el-dialog) {
    top: -100px !important;
}
</style>
